import React from 'react';
import { Feature, MediaItemValue } from '@fulcrumapp/fulcrum-core';
import { GPSTrackInfo, Metadata } from './media-displayer';
import TrackMapView from '../track-map-view';
import TrackMetadataView from '../track-metadata-view';

// These functions are used by both audio and video displayers, so
// we put them in their own file to share and make the intent clearer.
const noop: (e: Event) => void = () => {};
const mapView = (
  item: MediaItemValue,
  metadata: Metadata,
  cssClass: string,
  feature?: Feature,
  visible?: boolean,
  trackInfo?: GPSTrackInfo,
): React.ReactElement => (
  <TrackMapView
    className={cssClass}
    feature={feature}
    onTrackClick={trackInfo?.handleTrackClick || (() => {})}
    track={trackInfo?.activeTrack}
    visible={visible}
    currentPoint={trackInfo?.activeTrackPoint}
  />
);

const metadataView = (
  item: MediaItemValue,
  metadata: Metadata,
  cssClass: string,
  feature?: Feature,
  trackInfo?: GPSTrackInfo,
): React.ReactElement => (
  <TrackMetadataView
    className={cssClass}
    item={item}
    metadata={metadata}
    track={trackInfo?.activeTrack}
    currentPoint={trackInfo?.activeTrackPoint}
  />
);

export { mapView, metadataView, noop };
